export const selectAgingBalanceList = state => state.accounting.items;

export const selectAgingBalanceListCount = state => state.accounting.count;

export const selectAgingBalanceQueryOptions = state => state.accounting.options;

export const selectAgingBalanceResumeList = state =>
  state.accounting.resumeItems;

export const selectAgingBalanceResumeListCount = state =>
  state.accounting.resumeCount;

export const selectAgingBalanceResumeQueryOptions = state =>
  state.accounting.resumeOptions;
